<template>
  <div>
    <KTCodePreview v-bind:title="'Thông tin phiếu PO chia hàng'">
      <template v-slot:toolbar>
        <div
          class="row"
          v-if="mainModel.id"
        >
          <div>
            <b-row
              class="mb-4 ml-4"
              style="vertical-align: middle; display: inline"
            >
              <b-dropdown
                size="sm"
                id="dropdown-1"
                right
              >
                <template slot="button-content">
                  <i
                    style="font-size: 1rem"
                    class="fas fa-cog"
                  ></i>
                  <span class="font-weight-bolder">Thao tác</span>
                </template>
                <b-dropdown-item @click="reportClick">
                  <span>
                    <i
                      style="font-size: 1rem"
                      class="far fa-file-excel"
                    ></i>
                    &nbsp; Xuất Excel</span>
                </b-dropdown-item>
              </b-dropdown>
            </b-row>
          </div>
        </div>
      </template>
      <template v-slot:preview>
        <b-card
          no-body
          class="full-width"
        >
          <div>
            <div
              class="wizard wizard-4"
              id="kt_wizard_v4"
              data-wizard-state="step-first"
              data-wizard-clickable="true"
            >
              <!--begin: Wizard Nav-->
              <div
                class="wizard-nav"
                style="background-color: #eef0f8"
              >
                <div class="wizard-steps">
                  <div
                    class="wizard-step"
                    data-wizard-type="step"
                    data-wizard-state="current"
                  >
                    <div class="wizard-wrapper">
                      <div class="wizard-label">
                        <div class="wizard-title">Thông tin</div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="wizard-step ml-1"
                    data-wizard-type="step"
                    v-show="mainModel.id"
                  >
                    <div class="wizard-wrapper">
                      <div class="wizard-label">
                        <div class="wizard-title">Tệp đính kèm</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-custom card-shadowless rounded-top-0">
                <div class="card-body p-0">
                  <div class="row">
                    <div class="col-xl-12">
                      <div
                        class="py-8 px-4 py-lg-15 px-lg-4 pb-5 full-width"
                        data-wizard-type="step-content"
                        data-wizard-state="current"
                      >
                        <b-row class="mb-5">
                          <!-- INFO INPUT CONTROLS -->
                          <b-col
                            lg="6"
                            md="6"
                            sm="12"
                          >
                            <b-row v-if="mainModel.id">
                              <b-col
                                lg="6"
                                md="6"
                                sm="12"
                              >
                                <b-form-group>
                                  <template>
                                    <span>Mã phiếu:</span>
                                  </template>
                                  <p class="mt-2">{{ mainModel.code }}</p>
                                </b-form-group>
                              </b-col>
                              <b-col
                                lg="6"
                                md="6"
                                sm="12"
                              >
                                <b-form-group>
                                  <template>
                                    <span>Người tạo:</span>
                                  </template>
                                  <p class="mt-2">{{ mainModel.createdBy }}</p>
                                </b-form-group>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col
                                lg="6"
                                md="6"
                                sm="12"
                              >
                                <b-form-group>
                                  <template>
                                    <span>Ngày tạo:</span>
                                  </template>
                                  <p class="mt-2">{{ mainModel.createdAt }}</p>
                                </b-form-group>
                              </b-col>
                              <b-col
                                lg="6"
                                md="6"
                                sm="12"
                              >
                                <b-form-group>
                                  <template>
                                    <span>Tổng tiền:</span>
                                  </template>
                                  <p class="mt-2">
                                    {{ convertPrice(totalPrice) }}
                                  </p>
                                </b-form-group>
                              </b-col>
                            </b-row>

                            <b-row>
                              <b-col md="6">
                                <b-form-group class="required-control">
                                  <label>Nhà cung cấp:</label>
                                  <div class="float-right">
                                    <span @click="
                                        showProviderModal = !showProviderModal
                                      "><i
                                        class="fa fa-plus-circle text-primary pt-1"
                                        style="cursor: pointer"
                                      ></i></span>
                                  </div>
                                  <Autosuggest
                                    class="border-radius-none"
                                    :model="mainModel.providerName"
                                    :suggestions="filteredOptionsProvider"
                                    placeholder="nhà cung cấp"
                                    :limit="200"
                                    @select="onSelectedProvider"
                                    @change="onInputChangeProvider"
                                    suggestionName="suggestionName"
                                  />
                                </b-form-group>
                              </b-col>
                            </b-row>

                            <b-row>
                              <b-col
                                lg="12"
                                md="12"
                                sm="12"
                              >
                                <b-form-group :disabled="!editable">
                                  <label>Lý do nhập hàng:</label>
                                  <b-form-textarea
                                    size="sm"
                                    v-model="mainModel.importReason"
                                    :placeholder="'Nhập lý do nhập hàng...'"
                                    :rows="6"
                                    :max-rows="6"
                                  ></b-form-textarea>
                                </b-form-group>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col
                                lg="12"
                                md="12"
                                sm="12"
                              >
                                <b-form-group>
                                  <label>Ghi chú:</label>
                                  <b-form-textarea
                                    size="sm"
                                    v-model="mainModel.description"
                                    :placeholder="'Thêm nội dung ghi chú...'"
                                    :rows="6"
                                    :max-rows="6"
                                  ></b-form-textarea>
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </b-col>
                          <!-- INFO VAT INPUT CONTROLS -->
                          <b-col
                            lg="3"
                            md="3"
                            sm="12"
                          >
                            <b-form-group :disabled="!editable">
                              <label>Doanh nghiệp:</label>
                              <b-form-select
                                class="select-style"
                                v-model="mainModel.companyId"
                                :options="listCompany"
                                size="sm"
                                value-field="id"
                                text-field="name"
                              >
                              </b-form-select>
                            </b-form-group>
                            <b-form-group :disabled="!editable">
                              <label>Hình thức thanh toán:</label>
                              <b-form-select
                                class="select-style"
                                v-model="mainModel.importType"
                                :options="listImportType"
                                size="sm"
                                value-field="id"
                                text-field="name"
                              >
                              </b-form-select>
                            </b-form-group>
                            <b-form-group :disabled="!editable">
                              <label style="margin-bottom: 0.75rem">Chiết khấu:</label>
                              <b-row>
                                <b-col
                                  class="pr-0"
                                  cols="5"
                                >
                                  <b-form-select
                                    class="select-style"
                                    v-model="mainModel.discountType"
                                    :options="listAmountType"
                                    size="sm"
                                    value-field="id"
                                    text-field="name"
                                  >
                                  </b-form-select>
                                </b-col>
                                <b-col
                                  class="pl-0"
                                  cols="7"
                                >
                                  <b-form-input
                                    class="input-style text-right"
                                    size="sm"
                                    v-model="mainModel.discountAmount"
                                    v-mask="formater.currency"
                                    placeholder="Chiết khấu"
                                  ></b-form-input>
                                </b-col>
                              </b-row>
                            </b-form-group>

                            <POVat
                              :editable="true"
                              :mainModel="mainModel"
                            />
                          </b-col>
                          <!-- PAYMENT INPUT CONTROLS -->
                          <b-col
                            lg="3"
                            md="3"
                            sm="12"
                          >
                            <POPayment
                              :editable="true"
                              :mainModel="mainModel"
                            />
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col md="3">
                            <b-form-group :disabled="!editable">
                              <label>Người liên hệ:</label>
                              <Autosuggest
                                class="border-radius-none"
                                :model="searchEmployee"
                                :suggestions="filteredOptionsEmployee"
                                placeholder="người liên hệ"
                                :limit="10"
                                @select="onSelectedEmployee"
                                @change="onInputChangeEmployee"
                                suggestionName="suggestionName"
                              />
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row
                          class="mb-4"
                          v-if="editable"
                        >
                          <b-col
                            lg="2"
                            md="2"
                            sm="12"
                            class="pr-0"
                          >
                            <b-form-select
                              v-model="selectTypeSearch"
                              :options="listTypeSearch"
                              size="sm"
                              value-field="id"
                              text-field="name"
                            ></b-form-select>
                          </b-col>
                          <b-col
                            lg="6"
                            md="6"
                            sm="12"
                            class="pl-0 pr-0"
                          >
                            <treeselect
                              :load-options="loadOptions"
                              :multiple="true"
                              :async="true"
                              placeholder="Tìm kiếm theo tên, mã, mã vạch sản phẩm"
                              retryText="Thử lại..."
                              retryTitle="Nhấp thử lại"
                              searchPromptText="Nhập để tìm kiếm..."
                              loadingText="Đang tải..."
                              noResultsText="Không có kết quả"
                              :match-keys="['label', 'customLabel']"
                              v-model="selectedProducts"
                              :values="searchProduct"
                              :backspace-removes="false"
                              :clearable="false"
                              valueFormat="object"
                              :max-height="200"
                              @select="onSelectedProduct"
                            >
                              <label
                                slot="option-label"
                                slot-scope="{ node, labelClassName }"
                                :class="labelClassName"
                                class="border-bottom"
                              >
                                <span
                                  class="text-primary d-block px-0"
                                  v-if="node.raw.label"
                                >
                                  {{ node.raw.label }}
                                </span>
                                <b
                                  v-if="node.raw.customLabel"
                                  class="d-block px-0"
                                >
                                  {{ node.raw.customLabel }}</b>
                              </label>
                            </treeselect>
                          </b-col>
                          <b-col md="1">
                            <b-button
                              style="width: 40px"
                              variant="secondary"
                              size="sm"
                              v-b-tooltip.hover
                              title="Thêm sản phẩm"
                              @click="onAddProduct"
                            >
                              <i class="fas fa-arrow-down"></i>
                            </b-button>
                          </b-col>
                          <b-col
                            md="3"
                            v-if="!mainModel.id"
                          >
                            <div
                              class="d-flex justify-content-end"
                              v-if="!listProduct.length"
                            >
                              <b-button
                                variant="secondary"
                                size="sm"
                                class="font-weight-bolder"
                                @click="showModalImportProduct"
                                v-if="editable"
                              >
                                <i
                                  style="font-size: 1rem"
                                  class="far fa-file-excel"
                                ></i>Nhập SP từ excel
                              </b-button>
                            </div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col md="8">
                            <span class="font-weight-bolder lable-size">Danh sách sản phẩm:</span>
                          </b-col>
                          <b-col md="4">
                            <b-checkbox
                              v-model="mainModel.isVAT"
                              class="d-flex justify-content-end lable-size"
                              @change="onChangeVat"
                            >Đơn giá đã bao gồm VAT
                            </b-checkbox>
                          </b-col>
                        </b-row>
                        <b-table
                          :fields="fieldProduct"
                          :items="listProduct"
                          v-if="renderComponent"
                          hover
                          bordered
                          class="mt-4"
                        >
                          <template v-slot:cell(productName)="row">
                            <span
                              v-text="row.item.barCode"
                              style="font-size: 11px"
                              v-show="row.item.barCode"
                            ></span>
                            <br />
                            <span
                              v-text="row.item.productCode"
                              style="font-size: 12px"
                              v-show="row.item.productCode"
                            ></span>
                            <br />
                            <span
                              v-text="row.item.productName"
                              style="white-space: normal; color: #3699ff"
                            ></span>
                          </template>
                          <template v-slot:cell(unitPrice)="row">
                            <span v-if="
                                mainModel.status ===
                                PURCHASE_ORDER_STATUS.ACCOUNTANT
                              ">{{ convertPrice(row.item.unitPrice) }}</span>
                            <b-input
                              v-else
                              type="text"
                              size="sm"
                              class="input-style text-right"
                              v-model="row.item.unitPrice"
                              v-mask="formater.currency"
                            ></b-input>
                          </template>
                          <template v-slot:cell(discountAmount)="row">
                            <span v-if="
                                mainModel.status ===
                                PURCHASE_ORDER_STATUS.ACCOUNTANT
                              ">{{ convertPrice(row.item.discountAmount) }}</span>
                            <b-input
                              v-else
                              type="text"
                              size="sm"
                              class="input-style text-right"
                              v-model="row.item.discountAmount"
                              v-mask="formater.currency"
                            ></b-input>
                          </template>
                          <template v-slot:cell(salePrice)="row">
                            <span v-if="
                                mainModel.status ===
                                PURCHASE_ORDER_STATUS.ACCOUNTANT
                              ">{{ convertPrice(row.item.salePrice) }}</span>
                            <b-input
                              v-else
                              type="text"
                              size="sm"
                              class="input-style text-right"
                              v-model="row.item.salePrice"
                              v-mask="formater.currency"
                            ></b-input>
                          </template>
                          <template v-slot:cell(actions)="row">
                            <v-icon
                              small
                              class="text-danger text-center"
                              @click="deleteItemInArray(row.item.productId)"
                              v-b-tooltip
                              title="Xóa"
                            >mdi-delete</v-icon>
                          </template>
                        </b-table>
                        <hr
                          class="hr-text"
                          data-content="Danh sách chia hàng"
                          style="font-weight: 600"
                        />
                        <b-row
                          class="mb-4"
                          v-if="editable"
                        >
                          <b-col
                            lg="3"
                            md="3"
                            sm="6"
                            class="pr-0"
                          >
                            <treeselect
                              :options="stores"
                              v-model="selectedStores"
                              :multiple="true"
                              :normalizer="normalizer"
                              :backspace-removes="false"
                              placeholder="Chọn kho"
                              :max-height="200"
                              noResultsText="Không tìm thấy kết quả"
                              valueFormat="object"
                              :clearable="false"
                              :disabled="listProduct.length === 0"
                            ></treeselect>
                          </b-col>
                          <b-col md="1">
                            <b-button
                              style="width: 40px"
                              variant="secondary"
                              size="sm"
                              title="Thêm kho vào danh sách"
                              @click="onAddStore"
                              :disabled="selectedStores.length === 0"
                            >
                              <i class="fas fa-arrow-down"></i>
                            </b-button>
                          </b-col>
                        </b-row>
                        <b-table
                          :fields="fieldStores"
                          :items="inventories"
                          v-if="renderComponent"
                          hover
                          bordered
                          class="mt-4 col-md-6"
                        >
                          <template v-slot:cell(detail)="row">
                            <div
                              class="productCode"
                              style="cursor: pointer; color: blue"
                              @click="showModalShareGoods(row.item)"
                            >
                              <i
                                class="fa fa-shopping-cart"
                                v-b-tooltip.hover
                                title="Chia hàng"
                              ></i>
                            </div>
                          </template>
                          <template v-slot:cell(actions)="row">
                            <v-icon
                              small
                              class="text-danger"
                              @click="showDeleteAlert(row.item)"
                              v-b-tooltip
                              title="Xóa"
                            >mdi-delete</v-icon>
                          </template>
                        </b-table>
                        <hr
                          class="hr-text"
                          data-content="Bút toán"
                          style="font-weight: 600"
                          v-if="mainModel.id"
                        />
                        <b-row v-if="mainModel.code">
                          <b-col
                            md="12"
                            lg="12"
                            sm="12"
                          >
                            <StockSlipTransactions :stockCode="mainModel.code" />
                          </b-col>
                        </b-row>
                        <hr
                          class="hr-text"
                          data-content="Phiếu nhập xuất kho"
                          style="font-weight: 600"
                          v-if="checkViewStockSlip()"
                        />
                        <b-row v-if="checkViewStockSlip()">
                          <b-col
                            md="12"
                            lg="12"
                            sm="12"
                          >
                            <POTransaction :purchaseOrderId="mainModel.id" />
                          </b-col>
                        </b-row>
                        <hr
                          class="hr-text"
                          data-content="Lý do hủy phiếu"
                          style="font-weight: 600"
                        />
                        <b-row v-if="mainModel.code">
                          <b-col
                            md="12"
                            lg="12"
                            sm="12"
                          >
                            <CancelReason :stockCode="mainModel.code" />
                          </b-col>
                        </b-row>

                        <div
                          class="col-md-12"
                          style="padding-left: 0px"
                        >
                          <div class="mb-5 mt-5">
                            <b-button
                              v-if="checkEdit()"
                              v-bind:style="btnCreate"
                              size="sm"
                              variant="primary"
                              class="font-weight-bolder mr-4"
                              @click="onSubmit"
                            >
                              Lưu
                            </b-button>
                            <b-button
                              v-bind:style="btnCreate"
                              size="sm"
                              variant="secondary"
                              class="font-weight-bolder"
                              @click="onBack"
                            >
                              Hủy
                            </b-button>
                          </div>
                          <b-modal
                            v-model="showProviderModal"
                            hide-footer
                            title="Thêm mới nhà cung cấp"
                          >
                            <b-row class="mb-5">
                              <b-col>
                                <label class="labelInput">Tên nhà cung cấp:</label>
                                <b-form-input
                                  v-model="providerName"
                                  size="sm"
                                  placeholder="Nhập tên nhà cung cấp"
                                ></b-form-input>
                              </b-col>
                              <b-col>
                                <label class="labelInput">Số điện thoại nhà cung cấp:</label>
                                <b-form-input
                                  v-model="providerPhone"
                                  size="sm"
                                  placeholder="Nhập số điện thoại nhà cung cấp"
                                ></b-form-input>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col>
                                <b-button
                                  style="fontweight: 600; width: 70px"
                                  variant="primary"
                                  size="sm"
                                  @click="createProvider()"
                                >Lưu</b-button>
                                <b-button
                                  @click="
                                    showProviderModal = !showProviderModal
                                  "
                                  style="
                                    margin-left: 10px;
                                    font-weight: 600;
                                    width: 70px;
                                  "
                                  variant="secondary"
                                  size="sm"
                                >Hủy</b-button>
                              </b-col>
                            </b-row>
                          </b-modal>
                          <ImportProductPO
                            ref="stock-slip-excel"
                            :storeId="mainModel.storeId"
                            v-on:validData="validData"
                          />
                          <ShareGoods
                            ref="share-goods-modal"
                            v-on:onSubmit="onSubmitShareGoods"
                            :editable="true"
                          />
                        </div>
                      </div>

                      <div
                        class="py-4 mb-5 full-width"
                        data-wizard-type="step-content"
                      >
                        <div class="col-12">
                          <UploadFile
                            v-if="mainModel.id"
                            :id="mainModel.id"
                            :entity="'purchase-orders'"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end: Wizard Nav -->
        </b-card>
      </template>
    </KTCodePreview>
  </div>
</template>

<style>
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}
.table.b-table.table-sm > thead > tr > [aria-sort]:not(.b-table-sort-icon-left),
.table.b-table.table-sm
  > tfoot
  > tr
  > [aria-sort]:not(.b-table-sort-icon-left) {
  background-position: right calc(1.5rem / 2) center;
  padding-right: calc(0.3rem + 0.65em);
}
</style>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import moment from 'moment';
import ApiService from '@/core/services/api.service';
import { validationMixin } from 'vuelidate';
import { reduce, sumBy, reject } from 'lodash';
import {
  currencyMask,
  convertPrice,
  makeToastFaile,
  makeToastSuccess,
  unMaskPrice,
} from '../../../utils/common';
import {
  BASE_URL,
  PURCHASE_ORDER_TYPE,
  TIME_TRIGGER,
} from '../../../utils/constants';
import {
  AMOUNT_TYPE,
  PRODUCT_TYPE,
  PURCHASE_ORDER_STATUS,
} from '../../../utils/enum';
import axios from 'axios';

import decounce from 'debounce';
import ImportProductPO from '../../components/stock-slips/ImportProductPO';
import StockSlipTransactions from '../../components/StockSlipTransactions';
import POTransaction from '../../components/POTransaction';
import CancelReason from '../../components/stock-slips/CancelReason';
import { v4 } from 'uuid';
import KTWizard from '@/assets/js/components/wizard';
import KTUtil from '@/assets/js/components/util';
import { xoa_dau } from '../../../utils/common';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import fileDownload from '../../../utils/file-download';
import POPayment from '../../components/purchase-orders/POPayment';
import POVat from '../../components/purchase-orders/POVat';
import ShareGoods from '../../components/purchase-orders/ShareGoods';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import Swal from 'sweetalert2';
import UploadFile from '@/view/modules/upload/Upload';
import { showConfirmDialog } from '@/utils/sweet-alert2';
import { convertToNumber } from '@/utils/common';

export default {
  mixins: [validationMixin],
  data() {
    return {
      btnCreate: {
        fontWeight: '600!important',
        'margin-right': '-10px',
        width: '70px',
      },
      isNew: true,
      listProviders: [],
      searchProduct: '',
      listTypeSearch: [
        {
          id: null,
          name: 'Tất cả loại sản phẩm',
        },
        {
          id: 1,
          name: 'Sản phẩm',
        },
        {
          id: 2,
          name: 'Sản phẩm IMEI',
        },
      ],
      selectTypeSearch: null,
      listProduct: [],
      inputSearchProductProp: {
        class: 'autosuggest__input',
        placeholder: 'Tìm kiếm theo tên, mã, mã vạch sản phẩm',
        style: 'border-radius:0px!important',
        disabled: true,
      },
      formater: {
        currency: currencyMask,
      },
      showProviderModal: false,
      providerName: '',
      providerPhone: '',
      filteredOptionsProvider: [],
      optionsProvider: [],
      isSearching: false,
      inputPropStore: {
        class: 'autosuggest__input',
        placeholder: 'Chọn kho',
        style: 'border-radius:0px!important',
        disabled: false,
      },
      listAmountType: [
        {
          id: 1,
          name: 'Tiền mặt',
        },
        {
          id: 2,
          name: '%',
        },
      ],
      fieldProduct: [
        {
          key: 'productName',
          label: 'Sản phẩm',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            width: '25%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'inStockQuantity',
          label: 'Tồn',
          thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
          tdClass: 'text-right',
        },
        {
          key: 'prevUnitPrice',
          label: 'Giá nhấp nhất',
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'text-right',
          formatter: (value) => {
            return value ? convertPrice(value) : 0;
          },
        },
        {
          key: 'salePowerWeek',
          label: 'Sức bán tuần',
          thStyle: { fontWeight: 600, color: '#181c32', width: '7%' },
          tdClass: 'text-right',
        },
        {
          key: 'salePowerMonth',
          label: 'Sức bán tháng',
          thStyle: { fontWeight: 600, color: '#181c32', width: '7%' },
          tdClass: 'text-right',
        },
        {
          key: 'quantity',
          label: 'Số lượng',
          thStyle: { fontWeight: 600, color: '#181c32', width: '6%' },
          tdClass: 'text-right',
        },
        {
          key: 'unitPrice',
          label: 'Đơn giá (VAT)',
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'text-right',
        },
        {
          key: 'totalAmount',
          label: 'Thành tiền',
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'text-right',
          formatter: (value, key, item) => {
            if (!item) {
              return 0;
            }
            const totalAmount =
              unMaskPrice(item.quantity) * unMaskPrice(item.unitPrice);
            return convertPrice(totalAmount);
          },
        },
        {
          key: 'salePrice',
          label: 'Đơn giá bán',
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'text-right',
          formatter: (value) => {
            return value ? convertPrice(value) : 0;
          },
        },
      ],
      renderComponent: true,
      mainModel: {
        id: null,
        code: '',
        status: 1,
        providerId: null,
        providerName: '',
        description: '',
        storeId: null,
        discountAmount: 0,
        discountType: 1,
        vatAmount: 0,
        vatType: 2,
        cashAmount: 0,
        cashAccountCode: '',
        cashAccountName: '',
        transferAmount: 0,
        transferAccountCode: '',
        transferAccountName: '',
        payDate: null,
        vatCode: '',
        vatDate: '',
        createdAt: '',
        createdBy: '',
        importType: 1,
        importReason: '',
        isNew: true,
        companyId: null,
        isVAT: true,
      },
      PURCHASE_ORDER_STATUS: PURCHASE_ORDER_STATUS,
      listImportType: PURCHASE_ORDER_TYPE,
      hashName: null,
      filteredOptionsEmployee: [],
      optionsEmployee: [],
      searchEmployee: '',
      selectedProducts: [],
      listCompany: [],
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        };
      },
      stores: [],
      selectedStores: [],
      fieldStores: [
        {
          key: 'name',
          label: 'Kho',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            width: '50%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'quantity',
          label: 'Tổng SL',
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
          tdClass: 'text-right',
          formatter: (value, key, item) => {
            if (!item) {
              return 0;
            }
            const totalQuantity = sumBy(item.products, 'quantity');
            return totalQuantity ? convertPrice(totalQuantity) : 0;
          },
        },
        {
          key: 'totalAmount',
          label: 'Tổng tiền',
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
          tdClass: 'text-right',
          formatter: (value, key, item) => {
            if (!item) {
              return 0;
            }
            const totalAmount = this.calTotalAmountProducts(item.products);
            return convertPrice(totalAmount);
          },
        },
        {
          key: 'detail',
          label: 'Chia hàng',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
          tdClass: 'text-center',
        },
        {
          key: 'actions',
          label: '',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '5%',
          },
          tdClass: 'text-center',
        },
      ],
      inventories: [],
      isError: false,
    };
  },
  components: {
    KTCodePreview,
    ImportProductPO,
    StockSlipTransactions,
    POTransaction,
    CancelReason,
    Treeselect,
    POPayment,
    POVat,
    Autosuggest,
    ShareGoods,
    UploadFile,
  },
  created() {
    this.fetchStore();
    this.fetchProvider();
    this.getListEmployee();
    this.fetchCompany();
  },
  mounted() {
    this.mainModel.createdAt = moment().format('DD/MM/YYYY');
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Phiếu yêu cầu nhập hàng', route: '/purchase-orders' },
      { title: 'Thông tin phiếu PO chia hàng' },
    ]);
    if (this.$route.query.id) {
      this.mainModel.id = this.$route.query.id;
      this.mainModel.isNew = !!this.$route.query.isCreate;
      this.getInfoById();
    } else {
      this.fieldProduct.push({
        key: 'actions',
        label: '',
        thStyle: {
          fontWeight: 600,
          color: '#181c32',
          textAlign: 'center',
          width: '5%',
        },
        tdClass: 'text-center',
      });
    }
    // Initialize form wizard
    const hashName = this.$route.hash ? this.$route.hash.split('#')[1] : '';

    this.hashName = hashName === 'attach' ? 'attach' : null;

    const wizard = new KTWizard('kt_wizard_v4', {
      startStep: hashName === 'attach' ? 3 : 1, // initial active step number
      clickableSteps: true, // allow step clicking
    });

    wizard.on('beforeNext', function (/*wizardObj*/) {});

    wizard.on('change', function (/*wizardObj*/) {
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);
    });
  },
  computed: {
    totalPrice() {
      let total = 0;
      for (let index = 0; index < this.listProduct.length; index++) {
        const element = this.listProduct[index];
        total +=
          unMaskPrice(element.unitPrice) * unMaskPrice(element.quantity) -
          unMaskPrice(element.discountAmount);
      }

      const discountValue = this.mainModel.discountAmount
        ? unMaskPrice(this.mainModel.discountAmount)
        : 0;
      let discountAmount = discountValue;
      if (this.mainModel.discountType === AMOUNT_TYPE.PERCENT) {
        discountAmount = (discountValue * total) / 100;
      }

      total = total - discountAmount;
      const vatValue = this.mainModel.vatAmount
        ? unMaskPrice(this.mainModel.vatAmount)
        : 0;

      let vatAmount = vatValue;
      if (this.mainModel.vatType === AMOUNT_TYPE.PERCENT) {
        vatAmount = (vatValue * total) / 100;
      }

      total = parseInt(total) + parseInt(vatAmount);
      return total;
    },
    editable() {
      if (
        this.mainModel.status === PURCHASE_ORDER_STATUS.NEW ||
        this.mainModel.status === PURCHASE_ORDER_STATUS.PO_HEAD_CANCEL ||
        this.mainModel.status === PURCHASE_ORDER_STATUS.ACCOUNTANT_CANCEL
      ) {
        return true;
      }

      return false;
    },
  },
  methods: {
    showConfirmDialog,
    convertPrice,
    forceRerender() {
      this.renderComponent = false;

      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
    onSelectedProduct(option) {
      this.getMinPriceByProductId(option.id);
    },
    onInputChangProduct(text) {
      if (!text) {
        text = '';
      }
      this.searchProduct = text;
      this.debounceInputProduct();
    },
    onSubmit: async function () {
      if (
        !this.mainModel.providerName ||
        !this.mainModel.providerName.trim().length
      ) {
        this.mainModel.providerId = null;
      }
      if (!this.mainModel.providerId) {
        makeToastFaile('Vui lòng chọn nhà cung cấp!');
        return;
      }

      if (!this.listProduct || !this.listProduct.length) {
        makeToastFaile('Vui lòng nhập sản phẩm!');
        return;
      }

      if (this.mainModel.id) {
        this.onUpdate();
      } else {
        this.onCreate();
      }
    },
    onCreate() {
      this.isError = false;
      const listPro = [];
      this.listProduct.forEach((element) => {
        const quantity = convertToNumber({
          value: unMaskPrice(element.quantity),
        });
        const data = {
          productId: element.productId,
          quantity,
          unitPrice: element.unitPrice ? unMaskPrice(element.unitPrice) : 0,
          discountAmount: element.discountAmount
            ? unMaskPrice(element.discountAmount)
            : 0,
          salePowerWeek: element.salePowerWeek,
          salePowerMonth: element.salePowerMonth,
          prevUnitPrice: element.prevUnitPrice,
          quantityApprove: element.quantityApprove
            ? unMaskPrice(element.quantityApprove)
            : 0,
          salePrice: element.salePrice ? unMaskPrice(element.salePrice) : 0,
        };
        if (quantity > 0) {
          listPro.push(data);
        }
      });
      const inventoryItems = this.genInventory();
      this.checkStoreEmpty(inventoryItems);
      const data = {
        storeId: this.mainModel.storeId,
        providerId: this.mainModel.providerId,
        description: this.mainModel.description,
        importReason: this.mainModel.importReason,
        importType: this.mainModel.importType,
        inChargeEmployeeId: this.selectedEmployee,
        companyId: this.mainModel.companyId,
        listDetail: listPro,
        cashAmount: this.mainModel.cashAmount
          ? unMaskPrice(this.mainModel.cashAmount)
          : 0,
        cashAccountCode: this.mainModel.cashAccountCode,
        transferAmount: this.mainModel.transferAmount
          ? unMaskPrice(this.mainModel.transferAmount)
          : 0,
        transferAccountCode: this.mainModel.transferAccountCode,
        payDate: this.mainModel.payDate
          ? moment(this.mainModel.payDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
          : null,
        vatDate: this.mainModel.vatDate
          ? moment(this.mainModel.vatDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
          : null,
        vatType: this.mainModel.vatType,
        vatAmount: this.mainModel.vatAmount
          ? unMaskPrice(this.mainModel.vatAmount)
          : 0,
        vatCode: this.mainModel.vatCode,
        discountType: this.mainModel.discountType,
        discountAmount: this.mainModel.discountAmount
          ? unMaskPrice(this.mainModel.discountAmount)
          : 0,
        isVAT: this.mainModel.isVAT,
        inventoryItems: inventoryItems,
      };
      if (this.isNew === true && !this.isError) {
        this.isNew = false;
        ApiService.post('purchase-order/purchase-order-share', data)
          .then(({ data }) => {
            if (data.status === 1) {
              makeToastSuccess(data.message);
              this.onBack();
            } else {
              this.isNew = true;
              makeToastFaile(data.message);
            }
          })
          .catch((response) => {
            this.isNew = true;
            makeToastFaile(response.message);
          });
      }
    },
    onUpdate() {
      this.isError = false;
      const listPro = [];
      this.listProduct.forEach((element) => {
        const quantity = convertToNumber({
          value: unMaskPrice(element.quantity),
        });
        if (quantity > 0) {
          listPro.push({
            id: element.id,
            productId: element.productId,
            quantity,
            unitPrice: element.unitPrice ? unMaskPrice(element.unitPrice) : 0,
            discountAmount: element.discountAmount
              ? unMaskPrice(element.discountAmount)
              : 0,
            isNew: element.isNew,
            salePowerWeek: element.salePowerWeek,
            salePowerMonth: element.salePowerMonth,
            prevUnitPrice: element.prevUnitPrice,
            quantityApprove: element.quantityApprove
              ? unMaskPrice(element.quantityApprove)
              : 0,
            salePrice: element.salePrice ? unMaskPrice(element.salePrice) : 0,
          });
        }
      });

      listPro.map((x) => {
        if (x.isNew) delete x.id;

        delete x.isNew;
      });
      const inventoryItems = this.genInventory();
      this.checkStoreEmpty(inventoryItems);
      const data = {
        id: this.mainModel.id,
        providerId: this.mainModel.providerId,
        description: this.mainModel.description,
        importReason: this.mainModel.importReason,
        inChargeEmployeeId: this.selectedEmployee,
        companyId: this.mainModel.companyId,
        importType: this.mainModel.importType,
        listDetail: listPro,
        cashAmount: this.mainModel.cashAmount
          ? unMaskPrice(this.mainModel.cashAmount)
          : 0,
        cashAccountCode: this.mainModel.cashAccountCode,
        transferAmount: this.mainModel.transferAmount
          ? unMaskPrice(this.mainModel.transferAmount)
          : 0,
        transferAccountCode: this.mainModel.transferAccountCode,
        payDate: this.mainModel.payDate
          ? moment(this.mainModel.payDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
          : null,
        vatDate: this.mainModel.vatDate
          ? moment(this.mainModel.vatDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
          : null,
        vatType: this.mainModel.vatType,
        vatAmount: this.mainModel.vatAmount
          ? unMaskPrice(this.mainModel.vatAmount)
          : 0,
        vatCode: this.mainModel.vatCode,
        discountType: this.mainModel.discountType,
        discountAmount: this.mainModel.discountAmount
          ? unMaskPrice(this.mainModel.discountAmount)
          : 0,
        isVAT: this.mainModel.isVAT,
        inventories: inventoryItems,
      };

      if (this.isNew === true && !this.isError) {
        this.isNew = false;
        ApiService.put('purchase-order/purchase-order-share', data)
          .then(({ data }) => {
            if (data.status === 1) {
              this.isNew = true;
              makeToastSuccess(data.message);
              //this.onBack();
            } else {
              this.isNew = true;
              makeToastFaile(data.message);
            }
          })
          .catch((response) => {
            this.isNew = true;
            makeToastFaile(response.message);
          });
      }
    },
    fetchStore() {
      ApiService.get(`stores?limit=10000&page=1`).then(({ data }) => {
        this.stores = data.data.list_store;
      });
    },
    fetchProvider() {
      ApiService.get(`providers/getAll`).then(({ data }) => {
        this.listProviders = data.data.providers;
        this.optionsProvider = this.listProviders.map((element) => {
          return {
            id: element.id,
            name: element.name,
            suggestionName: element.name,
            numPaymentDate: element.numPaymentDate,
          };
        });
        this.filteredOptionsProvider = [...this.optionsProvider];
      });
    },
    fetchProduct(textSearch) {
      this.isSearching = true;

      const params = {
        storeId: this.mainModel.storeId,
        searchProduct: textSearch,
        searchType: this.selectTypeSearch,
      };

      return ApiService.query('purchase-order/search-product', { params }).then(
        ({ data }) => {
          const products = data.data;
          return products;
        },
      );
    },
    deleteItemInArray(productId) {
      for (var i = 0; i < this.listProduct.length; i++) {
        if (this.listProduct[i].productId === productId) {
          this.listProduct.splice(i, 1);
        }
      }
      for (let index = 0; index < this.inventories.length; index++) {
        const inventory = this.inventories[index];
        inventory.products = reject(inventory.products, (product) => {
          return product.productId == productId;
        });
      }
      this.calQuantityProduct();
    },
    onSelectedProvider(option) {
      this.mainModel.providerName = option.item.name;
      this.mainModel.providerId = option.item.id;
      const numDate = option.item.numPaymentDate;
      if (numDate > 0) {
        this.mainModel.payDate = moment()
          .add(numDate, 'days')
          .format('DD/MM/YYYY');
      }
      if (!numDate) {
        this.mainModel.payDate = '';
      }
    },
    onInputChangeProvider(text) {
      this.mainModel.providerName = text;
      const filteredData = this.optionsProvider
        .filter((item) => {
          return item.name.toLowerCase().indexOf(text.toLowerCase()) > -1;
        })
        .slice(0, this.limit);
      this.filteredOptionsProvider = [...filteredData];
    },
    createProvider: async function () {
      if (!this.providerName) {
        return;
      }

      const data = {
        name: this.providerName,
        phoneNo: this.providerPhone,
        status: 1,
      };

      ApiService.post('providers', data).then((response) => {
        const { status, message } = response.data.data;
        if (status === 1) {
          this.fetchProvider();
          this.showProviderModal = !this.showProviderModal;
          makeToastSuccess(message);
        } else {
          this.showProviderModal = !this.showProviderModal;
          makeToastFaile(message);
        }
      });
    },
    searchProductAPI() {
      if (!this.isSearching) {
        const textSearch = this.searchProduct;
        this.fetchProduct(textSearch);
      }
    },
    debounceInputProduct: decounce(function () {
      this.searchProductAPI();
    }, TIME_TRIGGER),
    showModalImportProduct() {
      this.$refs['stock-slip-excel'].showModal();
    },
    validData(data) {
      const { products, inventories } = data;
      this.listProduct = this.listProduct.concat(products);
      this.inventories = inventories.map((inventory) => {
        return {
          id: v4(),
          ...inventory,
        };
      });
      this.calQuantityProduct();
    },
    onBack() {
      this.$router.push({
        name: 'list-purchase-orders',
      });
    },
    getInfoById() {
      ApiService.get(`purchase-order/purchase-order-share/${this.mainModel.id}`)
        .then(({ data }) => {
          this.mainModel.status = data.data.status
            ? parseInt(data.data.status)
            : 1;
          this.mainModel.code = data.data.code ? data.data.code : '';
          this.mainModel.description = data.data.description
            ? data.data.description
            : '';
          this.mainModel.importReason = data.data.importReason
            ? data.data.importReason
            : '';
          this.mainModel.storeId = data.data.storeId;
          this.inputSearchProductProp.disabled = false;
          this.mainModel.providerName = data.data.providerName
            ? data.data.providerName
            : '';
          this.mainModel.providerId = data.data.providerId;
          this.mainModel.createdBy = data.data.createdByName
            ? data.data.createdByName
            : '';
          this.searchEmployee = data.data.inChargeEmployeeName
            ? data.data.inChargeEmployeeName
            : '';
          this.selectedEmployee = data.data.inChargeEmployeeId;
          this.mainModel.companyId = data.data.companyId;
          this.mainModel.createdAt = data.data.createdAt
            ? moment(data.data.createdAt).format('HH:mm:ss DD/MM/YYYY')
            : '';
          this.mainModel.discountAmount = data.data.discountAmount
            ? data.data.discountAmount
            : 0;
          this.mainModel.vatAmount = data.data.vatAmount
            ? data.data.vatAmount
            : 0;
          this.mainModel.isVAT = data.data.isVAT;
          this.mainModel.discountType = data.data.discountType
            ? data.data.discountType
            : 1;
          this.mainModel.vatType = data.data.vatType ? data.data.vatType : 2;
          this.mainModel.cashAmount = data.data.cashAmount
            ? data.data.cashAmount
            : 0;
          this.mainModel.cashAccountCode = data.data.cashAccountCode
            ? data.data.cashAccountCode
            : '';
          this.mainModel.transferAmount = data.data.transferAmount
            ? data.data.transferAmount
            : 0;
          this.mainModel.transferAccountCode = data.data.transferAccountCode
            ? data.data.transferAccountCode
            : '';
          this.mainModel.payDate = data.data.payDate
            ? moment(data.data.payDate).format('DD-MM-YYYY')
            : '';
          this.mainModel.vatDate = data.data.vatDate
            ? moment(data.data.vatDate).format('DD-MM-YYYY')
            : '';
          this.mainModel.cashAccountName = data.data.cashAccountName
            ? data.data.cashAccountName
            : '';
          this.mainModel.transferAccountName = data.data.transferAccountName
            ? data.data.transferAccountName
            : '';
          this.mainModel.vatCode = data.data.vatCode ? data.data.vatCode : '';
          this.mainModel.importType = data.data.type ? data.data.type : 1;
          this.listProduct = data.data.details.map((item) => {
            const totalAmount =
              item.quantity * item.unitPrice - item.discountAmount;
            return {
              ...item,
              totalAmount: totalAmount,
              isNew: this.mainModel.isNew,
            };
          });
          this.inventories = data.data.inventories.map((inventory) => {
            return {
              ...inventory,
            };
          });
          if (this.mainModel.isNew) {
            this.mainModel.id = null;
            this.mainModel.status = PURCHASE_ORDER_STATUS.NEW;
          }

          if (
            this.mainModel.status === PURCHASE_ORDER_STATUS.NEW ||
            this.mainModel.status === PURCHASE_ORDER_STATUS.PO_HEAD_CANCEL ||
            this.mainModel.status === PURCHASE_ORDER_STATUS.ACCOUNTANT_CANCEL
          ) {
            this.fieldProduct.push({
              key: 'actions',
              label: '',
              thStyle: {
                fontWeight: 600,
                color: '#181c32',
                textAlign: 'center',
                width: '5%',
              },
              tdClass: 'text-center',
            });
          }

          this.onChangeVat();
        })
        .catch(({ response }) => {
          makeToastFaile(response.$error);
        });
    },
    checkViewStockSlip() {
      if (this.mainModel.status === PURCHASE_ORDER_STATUS.ACCOUNTANT) {
        return true;
      }

      if (this.mainModel.status === PURCHASE_ORDER_STATUS.PURCHASE) {
        return true;
      }

      return false;
    },
    onInputChangeEmployee(text) {
      if (!text) {
        text = '';
      }
      this.searchEmployee = text;
      /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
      const filteredData = this.optionsEmployee
        .filter((item) => {
          const nameNoneSign = xoa_dau(item.name);
          return (
            item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            nameNoneSign.toLowerCase().indexOf(text.toLowerCase()) > -1
          );
        })
        .slice(0, this.limit);

      this.filteredOptionsEmployee = [...filteredData];
    },
    onSelectedEmployee(option) {
      this.searchEmployee = option.item.name;
      this.selectedEmployee = option.item.id;
    },
    getListEmployee() {
      ApiService.get('employees/getAll').then((data) => {
        const employees = data.data.data;
        this.optionsEmployee = employees.map((element) => {
          return {
            id: element.id,
            name: element.fullName,
            suggestionName: element.fullName,
          };
        });
      });
    },
    checkEdit() {
      const statusEditable = [
        PURCHASE_ORDER_STATUS.NEW,
        PURCHASE_ORDER_STATUS.PO_HEAD_CANCEL,
        PURCHASE_ORDER_STATUS.ACCOUNTANT_CANCEL,
        PURCHASE_ORDER_STATUS.ACCOUNTANT,
      ];
      if (statusEditable.includes(this.mainModel.status)) {
        return true;
      }

      return false;
    },
    async loadOptions({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const result = await this.fetchProduct(searchQuery);
        const options = (result || []).map((element) => {
          return {
            id: element.productId,
            label: element.productName,
            customLabel: '',
            productName: element.productName,
            productCode: element.productCode,
            barCode: element.barCode,
            salePowerWeek: element.totalSaleWeek,
            salePowerMonth: element.totalSaleMonth,
            prevUnitPrice: 0,
            unitPrice: element.originalPrice ? element.originalPrice : 0,
            quantity: 0,
            quantityApprove: 0,
            discountAmount: 0,
            totalAmount: element.originalPrice ? element.originalPrice : 0,
            inStockQuantity: element.quantityInStock
              ? element.quantityInStock
              : 0,
            salePrice: element.sellingPrice ? element.sellingPrice : 0,
            productType: element.productType,
          };
        });
        callback(null, options);
      }
    },
    onAddProduct() {
      if (!this.selectedProducts || !this.selectedProducts.length) {
        return makeToastFaile('Vui lòng chọn sản phẩm muốn thêm!');
      }

      const isCombo = this.selectedProducts
        .map((product) => product.productType)
        .includes(PRODUCT_TYPE.PRODUCT_COMBO);

      if (isCombo) {
        return makeToastFaile('Không hỗ trợ nhập kho sản phẩm combo');
      }

      const isService = this.selectedProducts
        .map((product) => product.productType)
        .includes(PRODUCT_TYPE.PRODUCT_SERVICE);

      if (isService) {
        return makeToastFaile('Không hỗ trợ nhập kho sản phẩm dịch vụ');
      }

      let isValidProduct = true;
      this.selectedProducts.forEach((product) => {
        const existedProduct = this.listProduct.find(
          (pro) => pro.productId === product.id,
        );
        if (existedProduct) {
          isValidProduct = false;
          return makeToastFaile(
            ` Sản phẩm ${product.productName} đã tồn tại trong danh sách!`,
          );
        }
      });
      if (!isValidProduct) {
        return;
      }

      const products = this.selectedProducts.map((product) => {
        return {
          ...product,
          productId: product.id,
          id: v4(),
          isNew: true,
        };
      });

      this.listProduct = products.concat(this.listProduct);

      if (this.inventories.length) {
        this.inventories.forEach((inventory) => {
          const inventoryProducts = products.map((product) => {
            return {
              ...product,
              id: v4(),
            };
          });
          inventory.products = inventoryProducts.concat(inventory.products);
        });
      }

      this.selectedProducts = [];
    },
    reportClick: async function () {
      const url = `${BASE_URL}purchase-order/export-excel-detail/${this.mainModel.id}`;
      await axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const fileName = fileDownload.getFileName(response);
        fileDownload.createFile(response.data, fileName);
      });
    },
    getMinPriceByProductId(productId) {
      ApiService.get(`purchase-order/min-price/${productId}`).then(
        ({ data }) => {
          if (data.status === 1) {
            const item = this.selectedProducts.find(
              (product) => product.id === productId,
            );
            if (item) {
              item.unitPrice = data.data;
              item.prevUnitPrice = data.data;
            }
          }
        },
      );
    },
    fetchCompany: async function () {
      ApiService.get('/company').then((response) => {
        this.listCompany = response.data.data;
        this.listCompany.unshift({
          id: null,
          name: 'Chọn doanh nghiệp',
        });
      });
    },
    onChangeVat() {
      const vatTableField = this.fieldProduct.find(
        (field) => field.key === 'unitPrice',
      );
      if (vatTableField) {
        vatTableField.label = this.mainModel.isVAT
          ? 'Đơn giá (VAT)'
          : 'Đơn giá';
      }
    },
    onAddStore() {
      const selectedStoreIds = this.selectedStores.map((store) => store.id);
      const existedProduct = this.inventories.find((inventory) =>
        selectedStoreIds.includes(inventory.storeId),
      );
      if (existedProduct) {
        return makeToastFaile('Kho hàng đã tồn tại trong danh sách!');
      }
      const stores = this.selectedStores.map((store) => {
        const inventoryProducts = this.listProduct.map((product) => {
          return {
            ...product,
            quantity: 0,
          };
        });

        return {
          storeId: store.id,
          name: store.name,
          shortName: store.shortName,
          id: v4(),
          products: inventoryProducts,
        };
      });

      this.inventories = stores.concat(this.inventories);

      this.selectedStores = [];
    },
    showDeleteAlert: function (item) {
      Swal.fire({
        title: 'Xóa kho hàng!',
        text: 'Bạn có chắc muốn xóa kho hàng này không ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
        position: 'top',
      }).then((result) => {
        if (result.dismiss != 'cancel') {
          this.inventories = reject(this.inventories, (inventory) => {
            return inventory.id == item.id;
          });
          this.calQuantityProduct();
        }
      });
    },
    showModalShareGoods(item) {
      this.$refs['share-goods-modal'].showModal(
        item.id,
        item.name,
        item.products,
      );
    },
    onSubmitShareGoods(resultData) {
      const inventoryFound = this.inventories.find(
        (inventory) => inventory.id === resultData.inventoryId,
      );
      if (!inventoryFound) {
        return;
      }
      inventoryFound.products = resultData.products;
      this.calQuantityProduct();
    },
    calQuantityProduct() {
      const allProducts = reduce(
        this.inventories,
        function (flattened, other) {
          return flattened.concat(other.products);
        },
        [],
      );
      this.listProduct.forEach((product) => {
        const groupProducts = allProducts.filter(
          (pro) => pro.productId === product.productId,
        );
        product.quantity = sumBy(groupProducts, 'quantity');
        product.quantityApprove = sumBy(groupProducts, 'quantity');
      });
    },
    calTotalAmountProducts(products) {
      let totalAmountOfProducts = 0;
      products.forEach(({ productId, quantity = 0 }) => {
        const productFound = this.listProduct.find(
          (product) => product.productId === productId,
        );
        const unitPrice = productFound ? productFound.unitPrice : 0;
        totalAmountOfProducts += unMaskPrice(unitPrice) * unMaskPrice(quantity);
      });
      return totalAmountOfProducts;
    },
    genInventory() {
      return this.inventories.map((inventory) => {
        const inventoryProducts = [];
        inventory.products.forEach((product) => {
          const quantity = convertToNumber({
            value: unMaskPrice(product.quantity),
          });
          if (quantity > 0) {
            inventoryProducts.push({
              productId: product.productId,
              quantity,
            });
          }
        });
        return {
          id: inventory.id,
          name: inventory.name,
          storeId: inventory.storeId,
          products: inventoryProducts,
          shortName: inventory.shortName,
        };
      });
    },
    async checkStoreEmpty(inventoryItems) {
      const findEmptyProd = inventoryItems.find(
        (item) => !item.products || !item.products.length,
      );
      if (!findEmptyProd) return;
      try {
        this.isError = true;
        const title = `Cửa hàng ${findEmptyProd.name} không có sản phẩm!`;
        const desc = 'Xoá cửa hàng khỏi danh sách chia hàng';
        await showConfirmDialog(title, desc);
        this.inventories = this.inventories.filter(
          (item) => item.storeId !== findEmptyProd.storeId,
        );
        this.isError = false;
        makeToastSuccess('Cập nhật thành công');
      } catch (err) {
        console.log('err::: ', err);
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/sass/pages/wizard/wizard-4.scss';
</style>